import { Suspense, lazy } from 'react';

const Component = lazy(() => import("./ScheduleOverview"));

function ScheduleOverview() {

    return (
        <div>
            <Suspense fallback={<div>loading...</div>}>
              <Component />
            </Suspense>
        </div>);

}

export default ScheduleOverview; 

